// <div id="my-list" phx-hooks="Sortable" data-sortable-handle-class={"sortable-block-handle"}>
//   <div id="my-list-item-a" data-sortable-for="my-list">
//     <button type="button" class="sortable-block-handle">Move me</button>
//     Item A
//   </div>
//   <div id="my-list-item-b" data-sortable-for="my-list">
//     <button type="button" class="sortable-block-handle">Move me</button>
//     Item B
//   </div>
//   <div id="my-list-item-c" data-sortable-for="my-list">
//     <button type="button" class="sortable-block-handle">Move me</button>
//     Item C
//   </div>
// </div>

export default {
  Sortable: {
    mounted() {
      this.initialize();
      this.sortPlaceholder = document.createElement('div');
      this.sortPlaceholder.className = 'bg-indigo-500 w-full h-1 rounded-sm absolute z-30';
    },

    updated() {
      this.initialize();
    },

    initialize() {
      if (this.sortInProgress === true) {
        this.stopSort();
      }

      this.sortableBlocks = Array.from(this.el.querySelectorAll(`[data-sortable-for="${this.el.dataset.name}"]`));

      this.addSortingEventListeners();
    },

    addSortingEventListeners() {
      for (let sortableBlock of this.sortableBlocks) {
        let handle = sortableBlock.getElementsByClassName(this.el.dataset.sortableHandleClass).item(0);

        this.handleMouseDown = this.handleClickSortableItemHandle.bind({ handle: handle, self: this });
        this.handleMouseMove = this.handleDragItem.bind(this);
        this.handleMouseUp = this.handleReleaseItem.bind(this);

        handle.addEventListener('mousedown', this.handleMouseDown, true);
      }
    },

    removeSortingEventListeners() {
      for (let sortableBlock of this.sortableBlocks) {
        const handle = sortableBlock.getElementsByClassName(this.el.dataset.sortableHandleClass).item(0);

        handle.removeEventListener('mousedown', this.handleMouseDown);
      }
    },

    handleClickSortableItemHandle(e) {
      // Wait until the mouse leave the button for a nicer effect
      this.handle.addEventListener('mouseleave', this.self.handleBeginDrag.bind(this.self), { once: true });
    },

    handleBeginDrag(e) {
      this.startSortFor(e.currentTarget.closest(`[data-sortable-for="${this.el.dataset.name}"]`));
    },

    handleDragItem(e) {
      this.sortableBlocks.every((sortableBlock, sortableBlockIndex) => {
        const sortableBlockRect = sortableBlock.getBoundingClientRect();

        if (sortableBlockRect.top < e.clientY) {
          if (e.clientY < sortableBlockRect.top + sortableBlockRect.height / 2) {
            // If dropped on top half of target element
            if (this.draggedBlockNewIndex === sortableBlockIndex) return false;

            sortableBlock.insertAdjacentElement('beforebegin', this.sortPlaceholder);
            this.targetBlock = sortableBlock;
            this.position = 'before';
            this.draggedBlockNewIndex = sortableBlockIndex;

            // If the draggedBlock came before the destination or is in the same position,
            // it must be excluded from the count
            if (this.draggedBlockNewIndex > this.draggedBlockOldIndex) this.draggedBlockNewIndex--;
          } else if (e.clientY < sortableBlockRect.bottom) {
            // If dropped on bottom half of target element
            if (this.draggedBlockNewIndex === sortableBlockIndex + 1) return false;

            sortableBlock.insertAdjacentElement('afterend', this.sortPlaceholder);
            this.targetBlock = sortableBlock;
            this.position = 'after';
            this.draggedBlockNewIndex = sortableBlockIndex + 1;

            // If the draggedBlock came before the destination or is in the same position,
            // it must be excluded from the count
            if (this.draggedBlockNewIndex > this.draggedBlockOldIndex) this.draggedBlockNewIndex--;
          }
        }
        return true;
      });
    },

    startSortFor(draggedBlock) {
      this.sortInProgress = true;
      this.el.classList.add('sort-in-progress');
      document.body.style.cursor = 'pointer';

      this.draggedBlock = draggedBlock;
      this.draggedBlockOldIndex = this.sortableBlocks.indexOf(this.draggedBlock);
      this.draggedBlockNewIndex = null;

      document.addEventListener('mousemove', this.handleMouseMove, true);
      document.addEventListener('mouseup', this.handleMouseUp, true);
    },

    stopSort() {
      this.sortInProgress = false;
      this.el.classList.remove('sort-in-progress');
      document.body.style.cursor = 'initial';
      document.removeEventListener('mousemove', this.handleMouseMove, true);
      document.removeEventListener('mouseup', this.handleMouseUp, true);

      this.sortPlaceholder.remove();

      this.removeSortingEventListeners();

      this.draggedBlock = null;
      this.draggedBlockOldIndex = null;
      this.draggedBlockNewIndex = null;
    },

    handleReleaseItem(e) {
      let eventTarget = this.draggedBlock.dataset.eventTarget;
      let eventData = {
        sortable_name: this.draggedBlock.dataset.sortableFor,
        dragged_block_value: this.draggedBlock.dataset.value,
        target_block_value: this.targetBlock.dataset.value,
        position: this.position,
        old_index: this.draggedBlockOldIndex,
        new_index: this.draggedBlockNewIndex,
      };

      if (eventTarget) this.pushEventTo(eventTarget, 'sortable_blocks_reordered', eventData);
      else this.pushEvent('sortable_blocks_reordered', eventData);
      this.stopSort();
    },
  },
};
